<template>
  <v-container>
    <v-card class="mx-0 my-0 px-0 py-0">
      <v-data-table
          v-model="selectedItemList"
          :items="itemList.slice(1)"
          item-key="id"
          :height="height"
          :headers="[{text: '', value: 'created_on', sortable: false, filterable: true, divider: false, width: 30}]"
          :options="options"
          hide-default-header
          :loading="loading"
          show-select
          single-select
          hide-default-footer
          @item-selected="onSelected"
      >
        <template v-slot:item.created_on="{item}">
          <v-list-item-content>
            <v-list-item-subtitle>{{ item.created_on | moment("DD.MM.YY HH:mm") }}</v-list-item-subtitle>
            <v-list-item-subtitle>{{ item.created_by_name }}</v-list-item-subtitle>
            <v-list-item-subtitle v-if="item.source_version !== null">ver. {{ item.source_version }}</v-list-item-subtitle>
          </v-list-item-content>
        </template>
        <template v-slot:footer>
          <v-toolbar height="36" rounded="0" elevation="1">
            <v-btn
                small
                @click="onBtnClose()"
            >
              {{ $t('cancel') }}
            </v-btn>
            <v-spacer></v-spacer>
            <BaseConfirmBtn
                :labels="restoreLabels"
                @click="onBtnRestore()"
                :disabled="selectedItemList.length === 0"
            ></BaseConfirmBtn>
          </v-toolbar>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>

import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import BaseConfirmBtn from "@/components/Base/BaseConfirmBtn";

export default {
  name: 'HistoryList',
  props: {
    value: {type: [Object], default: null},
    height: {type: [Number], default: window.innerHeight},
    isDataChange: {type: [Boolean], default: false},
    onClose: {
      type: [Function], default: function () {
      }
    },
    onRestore: {
      type: [Function], default: function () {
      }
    },
    dtoFilterRestoreModel: {type: [String], default: null},
    filterRestoreUid: {default: null},
    dtoDetailModel: {type: [String], default: 'HistoryDetailQueryDTO'},
    dtoListModel: {type: [String], default: 'HistoryListQueryDTO'},
  },

  components: {
    BaseConfirmBtn
  },

  computed: {
    ...mapGetters('HistoryTable', ['getColumns']),
    ...mapFields('HistoryTable', ['errorMessage', 'totalRecords',
      'editedItem', 'itemList', 'editedItemCommon', 'confirm_request', 'filters',
      'loading', 'commandLoading', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'statusCustomerOrder']),
  },

  watch: {
    editedItem: {
      handler(newValue, oldValue) {
        // console.log('watch', newValue, oldValue)
        this.$emit('input', newValue.item)
      },
      deep: true
    },
  },

  methods: {
    ...mapActions('HistoryTable', ['openWebSocket', 'fetchItemList', 'fetchItem',
      'fetchSaveEditedItem', 'fetchAction', 'fetchRequest',]),

    onSelected({item, value}) {
      // console.log('onSelected', item, value)
      if (value) {
        // console.log('onSelected', item, value)
        this.fetchItem({itemUid: item.uid, dto_detail_model: this.dtoDetailModel,})
      } else {
        // console.log('offSelected', item, value, this.savedEditedItem)
        this.$emit('input', this.savedEditedItem)
      }
    },

    onBtnClose() {
      this.selectedItemList = []
      this.$emit('input', this.savedEditedItem)
      this.onClose()
    },

    onBtnRestore() {
      this.selectedItemList = []
      this.onRestore(this.editedItem)
    },
  },

  async mounted() {
    // console.log('mounted HistoryList', this.dtoFilterRestoreModel, this.value)
    this.savedEditedItem = JSON.parse(JSON.stringify(this.value))
    this.filters = [
        // {param_compare: 'source_name', value: this.dtoFilterRestoreModel},
        {param_compare: 'source_uid', value: this.filterRestoreUid},
    ]
    await this.fetchItemList(this.dtoListModel)
  },

  created() {
  },

  destroyed() {
  },

  beforeCreate() {
  },

  beforeDestroy() {
  },

  data() {
    return {
      savedEditedItem: null,
      restoreLabels: {
        btn: this.$t('restore'),
        confirm: this.$t('agree'),
        cancel: this.$t('cancel'),
        text: this.$t('are_you_sure'),
      },
      options: {
        page: 1,
        itemsPerPage: -1,
        sortBy: ['id'],
        sortDesc: [true],
        multiSort: false,
        mustSort: false,
        descending: true,
      },
    }
  }
}
</script>

<style>
.row_even {
}
</style>

<i18n>
{
  "en": {
    "history": "History",
    "cancel": "Cancel",
    "restore": "Restore",
    "are_you_sure": "Are you sure?",
    "agree": "Agree"
  },
  "de": {
    "history": "Geschichte",
    "cancel": "Stornieren",
    "restore": "Wiederherstellen",
    "are_you_sure": "Bist du sicher?",
    "agree": "Stimme zu"
  }
}
</i18n>
